import { render, staticRenderFns } from "./CarGene.vue?vue&type=template&id=01006b99&"
import script from "./CarGene.vue?vue&type=script&lang=js&"
export * from "./CarGene.vue?vue&type=script&lang=js&"
import style0 from "./CarGene.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports